var config;

config = {
  api: {
    root: 'http://netcatbackup.qopsrv.net/view/',
    corsProxy: 'http://netcatbackup.qopsrv.net/view/',
    testData: '/testdata/'
  },
  localData: false,
  preloadingThumbs: true,
  preloadPageNum: 6
};

module.exports = config;
